<template>
  <section class="eva-page">
    <v-row>
      <v-col
        cols="12"
        offset="0"
        md="10"
        offset-md="1"
      >
        <div class="eva-top">
          <v-breadcrumbs
            large
            :items="crumbs"
            divider="/"
            class="pl-0 eva-breadcrumbs"
          />

          <div class="eva-titlebar">
            <div class="eva-title">
              <v-icon
                color="primary"
                class="mr-2"
              >
                mdi-school
              </v-icon>

              <span class="primary--text">
                Ficha de Formação
              </span>
            </div>

            <v-spacer />

            <v-btn
              v-if="formacao"
              color="primary"
              outlined
              :disabled="loading || duplicating"
              :loading="duplicating"
              @click="openDuplicateDialog"
            >
              <v-icon left>
                mdi-content-copy
              </v-icon>

              Duplicar formação
            </v-btn>
          </div>
        </div>

        <v-card
          class="eva-card mt-6"
          elevation="10"
        >
          <v-card-title
            class="eva-card__title primary white--text"
          >
            <div class="d-flex align-center">
              <v-icon
                class="mr-2"
                color="white"
              >
                mdi-school-outline
              </v-icon>

              <span class="font-weight-bold">
                Formação
              </span>
            </div>
          </v-card-title>

          <v-card-text class="pt-6">
            <v-progress-linear
              v-if="loading"
              indeterminate
              class="global-loader mb-4"
            />

            <template v-if="loading">
              <v-row>
                <v-col cols="12" md="6">
                  <v-skeleton-loader type="text" />
                </v-col>

                <v-col cols="12" md="6">
                  <v-skeleton-loader type="text" />
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12">
                  <v-skeleton-loader type="text" />
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12">
                  <v-skeleton-loader type="text" />
                </v-col>
              </v-row>

              <v-row
                align="center"
                justify="space-around"
              >
                <v-skeleton-loader type="button" />
              </v-row>
            </template>

            <Formacao
              v-else
              method="update"
              :formacao="formacao"
            />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- ======================================================= -->
    <!-- MODAL DUPLICAÇÃO                                       -->
    <!-- ======================================================= -->

    <v-dialog
      v-model="duplicateDialog"
      max-width="620"
      persistent
    >
      <v-card class="duplicate-dialog-card">

        <!-- HEADER -->
        <div class="duplicate-dialog-header">
          <div class="duplicate-dialog-icon">
            <v-icon
              color="primary"
              size="30"
            >
              mdi-content-copy
            </v-icon>
          </div>

          <div class="duplicate-dialog-header-text">
            <div class="duplicate-dialog-title">
              Duplicar formação
            </div>

            <div class="duplicate-dialog-subtitle">
              Escolha como pretende criar a nova formação.
            </div>
          </div>

          <v-spacer />

          <v-btn
            icon
            :disabled="duplicating"
            @click="duplicateDialog = false"
          >
            <v-icon>
              mdi-close
            </v-icon>
          </v-btn>
        </div>

        <v-divider />

        <!-- CONTEÚDO -->
        <v-card-text class="duplicate-dialog-content">
          <div class="duplicate-question">
            Deseja transferir também a lista de participantes?
          </div>

          <div class="duplicate-description">
            Pode manter os participantes desta formação ou começar com a lista
            vazia e adicionar novos participantes posteriormente.
          </div>

          <!-- TRANSFERIR PARTICIPANTES -->
          <v-card
            class="duplicate-option"
            outlined
            ripple
            :disabled="duplicating"
            @click="duplicateTraining(true)"
          >
            <v-card-text class="duplicate-option-content">
              <div
                class="
                  duplicate-option-icon
                  duplicate-option-icon--primary
                "
              >
                <v-icon
                  color="primary"
                  size="30"
                >
                  mdi-account-multiple-check-outline
                </v-icon>
              </div>

              <div class="duplicate-option-text">
                <div class="duplicate-option-title">
                  Transferir participantes
                </div>

                <div class="duplicate-option-description">
                  A nova formação ficará com os mesmos participantes.
                </div>
              </div>

              <v-progress-circular
                v-if="duplicating"
                indeterminate
                color="primary"
                size="22"
                width="2"
              />

              <v-icon
                v-else
                color="primary"
              >
                mdi-chevron-right
              </v-icon>
            </v-card-text>
          </v-card>

          <!-- LISTA VAZIA -->
          <v-card
            class="duplicate-option mt-3"
            outlined
            ripple
            :disabled="duplicating"
            @click="duplicateTraining(false)"
          >
            <v-card-text class="duplicate-option-content">
              <div class="duplicate-option-icon">
                <v-icon
                  size="30"
                >
                  mdi-account-off-outline
                </v-icon>
              </div>

              <div class="duplicate-option-text">
                <div class="duplicate-option-title">
                  Começar com lista vazia
                </div>

                <div class="duplicate-option-description">
                  Nenhum participante será copiado para a nova formação.
                </div>
              </div>

              <v-progress-circular
                v-if="duplicating"
                indeterminate
                size="22"
                width="2"
              />

              <v-icon v-else>
                mdi-chevron-right
              </v-icon>
            </v-card-text>
          </v-card>

          <v-alert
            type="info"
            outlined
            dense
            class="mt-5 mb-0 duplicate-info"
          >
            As assinaturas e avaliações dos participantes nunca serão copiadas
            para a nova formação.
          </v-alert>
        </v-card-text>

        <v-divider />

        <!-- FOOTER -->
        <v-card-actions class="duplicate-dialog-actions">
          <v-spacer />

          <v-btn
            text
            :disabled="duplicating"
            @click="duplicateDialog = false"
          >
            Cancelar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </section>
</template>

<script>
import Formacao from "@/components/Formacoes/Formacao";
import FormacoesAPI from "@/api/Formacoes.js";

const DUPLICATE_STORAGE_KEY =
  "training_duplicate_data";

export default {
  name: "UpdateFormacoes",

  components: {
    Formacao,
  },

  data: () => ({
    formacao: null,

    loading: true,

    duplicating: false,

    duplicateDialog: false,
  }),

  mounted() {
    if (
      !this.$store.getters.hasPermission([
        "super",
        "trainings.read",
        "trainings.manage",
      ])
    ) {
      this.$router.push("/admin");

      return;
    }

    this.loadFormacao();
  },

  computed: {
    crumbs() {
      return [
        {
          text: "Dashboard",
          disabled: false,
          to: "/admin",
          exact: true,
        },
        {
          text: "Listagem de formações",
          disabled: false,
          to: "/trainings",
          exact: true,
        },
        {
          text: "Ficha de Formação",
          disabled: true,
          to: window.location.href,
          exact: true,
        },
      ];
    },
  },

  methods: {
    /*
     * =========================================================
     * CARREGAR FORMAÇÃO
     * =========================================================
     */

    loadFormacao() {
      this.loading =
        true;

      FormacoesAPI
        .get(
          this.$route.params.id
        )
        .then(({ data }) => {
          this.formacao =
            data;
        })
        .catch((error) => {
          const message =
            error?.response?.data?.message
            || error?.response?.data?.error
            || "Não foi possível carregar a formação.";

          this.showError(
            message
          );
        })
        .finally(() => {
          this.loading =
            false;
        });
    },

    /*
     * =========================================================
     * ABRIR MODAL DUPLICAÇÃO
     * =========================================================
     */

    openDuplicateDialog() {
      if (
        !this.formacao
        || this.loading
        || this.duplicating
      ) {
        return;
      }

      this.duplicateDialog =
        true;
    },

    /*
     * =========================================================
     * DUPLICAR
     * =========================================================
     */

    duplicateTraining(
      copyParticipants
    ) {
      if (
        !this.formacao
        || this.duplicating
      ) {
        return;
      }

      this.duplicating =
        true;

      const duplicateData = {
        /*
         * =====================================================
         * DADOS MANTIDOS
         * =====================================================
         */

        id_tipo_formacao:
          this.formacao.id_tipo_formacao
          || null,

        obra_id:
          this.formacao.obra_id
          || null,

        tipo_acao:
          this.formacao.tipo_acao
          || null,

        documentos_entregues:
          this.formacao.documentos_entregues
          ?? null,

        /*
         * =====================================================
         * NOVA FORMAÇÃO
         * =====================================================
         */

        status:
          "draft",

        /*
         * Estes campos ficam vazios.
         */
        data:
          null,

        hora_inicio:
          null,

        duracao_minutos:
          null,

        numero_acao:
          null,

        /*
         * =====================================================
         * VALORES DINÂMICOS
         * =====================================================
         *
         * Copia:
         * - objetivo
         * - conteúdo
         * - documento referência
         * - qualquer outro campo dinâmico
         */

        valores:
          (
            this.formacao.valores
            || []
          ).map((valor) => {
            return {
              id_formacao_campo:
                valor.id_formacao_campo,

              valor_texto:
                valor.valor_texto
                ?? null,

              valor_json:
                valor.valor_json
                ?? null,
            };
          }),

        /*
         * =====================================================
         * FORMADORES
         * =====================================================
         *
         * Os formadores são sempre copiados.
         *
         * Não copiamos:
         * - id
         * - assinatura
         * - assinatura_path
         * - signed_at
         */

        formadores:
          (
            this.formacao.formadores
            || []
          ).map((formador) => {
            return {
              codigo_funcionario:
                formador.codigo_funcionario
                || null,

              nome:
                formador.nome
                || null,
            };
          }),

        /*
         * =====================================================
         * PARTICIPANTES
         * =====================================================
         *
         * Só são copiados caso o utilizador escolha
         * "Transferir participantes".
         */

        participantes:
          copyParticipants
            ? (
                this.formacao.participantes
                || []
              ).map(
                (participante) => {
                  const isExternal =
                    !!participante.is_external;

                  const externalManual =
                    isExternal
                    && !participante.codigo_funcionario;

                  return {
                    codigo_funcionario:
                      participante.codigo_funcionario
                      || null,

                    is_external:
                      isExternal,

                    external_manual:
                      externalManual,

                    nome:
                      participante.nome
                      || null,

                    added_during_signing:
                      false,
                  };
                }
              )
            : [],
      };

      try {
        sessionStorage.setItem(
          DUPLICATE_STORAGE_KEY,
          JSON.stringify(
            duplicateData
          )
        );

        this.duplicateDialog =
          false;

        this.$router
          .push({
            path:
              "/trainings/create",

            query: {
              duplicate:
                "1",
            },
          })
          .catch((error) => {
            if (
              error
              && error.name
                !== "NavigationDuplicated"
            ) {
              throw error;
            }
          });
      } catch (error) {
        console.error(
          "[UpdateFormacoes] Erro ao duplicar formação:",
          error
        );

        this.showError(
          "Não foi possível preparar a duplicação da formação."
        );
      } finally {
        this.duplicating =
          false;
      }
    },

    /*
     * =========================================================
     * HELPERS
     * =========================================================
     */

    showError(message) {
      alert(message);
    },
  },
};
</script>

<style scoped>
.eva-page {
  padding-bottom: 32px;
}

.eva-top {
  margin-top: 8px;
}

.eva-breadcrumbs :deep(.v-breadcrumbs__item) {
  font-size: 13px;
}


/*
 * ============================================================
 * TITLE BAR
 * ============================================================
 */

.eva-titlebar {
  display: flex;
  align-items: center;
  width: 100%;
  gap: 12px;
  margin-top: 10px;
}

.eva-title {
  display: flex;
  align-items: center;
  font-size: 22px;
  font-weight: 800;
  letter-spacing: 0.2px;
}


/*
 * ============================================================
 * CARD
 * ============================================================
 */

.eva-card {
  border-radius: 18px;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.06);
}

.eva-card__title {
  font-weight: 800;
  letter-spacing: 0.2px;
}


/*
 * ============================================================
 * MODAL DUPLICAR FORMAÇÃO
 * ============================================================
 */

.duplicate-dialog-card {
  border-radius: 18px !important;
  overflow: hidden;
}

.duplicate-dialog-header {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 22px 24px;
}

.duplicate-dialog-header-text {
  min-width: 0;
}

.duplicate-dialog-icon {
  width: 52px;
  height: 52px;
  min-width: 52px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 14px;

  background:
    rgba(25, 118, 210, 0.08);
}

.duplicate-dialog-title {
  font-size: 21px;
  line-height: 1.25;
  font-weight: 800;
}

.duplicate-dialog-subtitle {
  margin-top: 4px;

  font-size: 13px;

  color:
    rgba(0, 0, 0, 0.55);
}

.duplicate-dialog-content {
  padding: 26px 24px !important;
}

.duplicate-question {
  font-size: 18px;
  line-height: 1.4;
  font-weight: 700;

  margin-bottom: 7px;
}

.duplicate-description {
  font-size: 14px;
  line-height: 1.55;

  color:
    rgba(0, 0, 0, 0.62);

  margin-bottom: 22px;
}


/*
 * ============================================================
 * OPÇÕES
 * ============================================================
 */

.duplicate-option {
  border-radius: 14px !important;

  cursor: pointer;

  transition:
    border-color 0.15s ease,
    background-color 0.15s ease,
    transform 0.15s ease;
}

.duplicate-option:hover {
  border-color:
    var(--v-primary-base) !important;

  background:
    rgba(25, 118, 210, 0.035);

  transform:
    translateY(-1px);
}

.duplicate-option-content {
  display: flex;
  align-items: center;

  gap: 15px;

  padding: 18px !important;
}

.duplicate-option-icon {
  width: 50px;
  height: 50px;
  min-width: 50px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 12px;

  background:
    rgba(0, 0, 0, 0.05);
}

.duplicate-option-icon--primary {
  background:
    rgba(25, 118, 210, 0.09);
}

.duplicate-option-text {
  flex: 1;
  min-width: 0;
}

.duplicate-option-title {
  font-size: 16px;
  font-weight: 800;

  margin-bottom: 3px;
}

.duplicate-option-description {
  font-size: 13px;
  line-height: 1.45;

  color:
    rgba(0, 0, 0, 0.58);
}

.duplicate-info {
  border-radius: 10px;
}


/*
 * ============================================================
 * FOOTER
 * ============================================================
 */

.duplicate-dialog-actions {
  padding: 12px 18px !important;
}


/*
 * ============================================================
 * RESPONSIVE
 * ============================================================
 */

@media (max-width: 700px) {
  .eva-titlebar {
    align-items: flex-start;
    flex-direction: column;
  }

  .eva-titlebar .v-btn {
    align-self: stretch;
  }
}

@media (max-width: 600px) {
  .duplicate-dialog-header {
    padding: 18px;
  }

  .duplicate-dialog-content {
    padding: 20px 18px !important;
  }

  .duplicate-dialog-icon {
    width: 44px;
    height: 44px;
    min-width: 44px;
  }

  .duplicate-dialog-title {
    font-size: 19px;
  }

  .duplicate-question {
    font-size: 16px;
  }

  .duplicate-option-content {
    padding: 15px !important;
  }

  .duplicate-option-icon {
    width: 44px;
    height: 44px;
    min-width: 44px;
  }
}
</style>